
import Sidebar from "./Sidebar.vue";
import HeaderBar from "./Header.vue";
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  reactive,
  toRaw,
} from "vue";
import { Vendor } from "@/classes/vendor";
import axios from "../../axios-vendor";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default defineComponent({
  components: {
    Sidebar,
    HeaderBar,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const visible = ref<any>();
    const userId = ref<any>(window.localStorage.getItem("PAYMENT_PORTAL_ID"));
    const form = reactive({
      is_prompt: "",
    });
    const doneNotification = ref(false);
    const notifications = ref([]);
    const notificationCount = ref(0);
    const getUser = async () => {
        const url = 'auth-vendor';
        const response = await axios.get(url);
        const u: Vendor = response.data.data;
        await store.dispatch('AuthVendor/setVendor', new Vendor(
          u.id,
          u.email,
          u.vendor_name,
          u.vendor_id,
          u.address,
          u.contact_no,
          u.org_id,
          u.first_time_logged_in
        ));
        if(response.data.data.first_time_logged_in === true) {
          logout()
        } 
    };

    const logout = () => {
      store.dispatch('Auth/logout')
      window.localStorage.removeItem('PAYMENT_PORTAL_VENDOR_TOKEN')
      window.localStorage.removeItem('PAYMENT_PORTAL_VENDOR_ID')
      window.location.href = '/login'
    }

    const notification = async (payload = { page: 1 }) => {
        await store.dispatch("NotificationVendor/index", payload).then((res) => {
        const unread = res.data.data.filter(
          (notif: any) => notif.is_read === false
        );
        notificationCount.value = unread.length;
        console.log(unread.length)
        notifications.value = res.data;

        doneNotification.value = true;
      });
    };

    const handleOk = (e: MouseEvent) => {
      visible.value = false;
    };
    
    onMounted(() => {
      notification();
      getUser();
    });
    
    const auth_vendor = computed(() => store.getters["AuthVendor/auth_vendor"]);

    return {
      selectedKeys: ref<string[]>(["0"]),
      collapsed: ref<boolean>(false),
      auth_vendor,
      userId,
      form,
      visible,
      doneNotification,
      notifications,
      notificationCount,
      handleOk,
      notification
    };
  },
});
